$.noConflict();
window.SNC = window.SNC || {};
window.SNC.Don = {};



window.SNC.Don.Main = (function(Don, $) {



    function reality(els) {

        var $predefs = (els.predefs) ? $(els.predefs) : null,

            $libre = $(els.libre),

            $reel =  $(els.reel),

            $reelZone = $(els.reelZone);



        return function() {

            var s = '', montant;



            if ($libre.val()) {

                montant = $libre.val();

                montant = montant.replace(/\s/, '');

                montant = montant.replace(/[\.,].*$/, '');

                montant = montant.replace(/\D+$/, '');

            } else {

                if (($predefs) && ($predefs.length)) {

                    montant = $predefs.filter(':checked').val();

                }

            }





            if (montant) {

                montant = montant/3;

                if (parseInt(montant, 10) == montant) {

                    s = montant;

                } else {

                    s = new Intl.NumberFormat('fr-FR', {

                        minimumFractionDigits: 2,

                        maximumFractionDigits: 2

                    }).format(montant);

                }



            }



            if (montant) {

                $reel.html(s + '&nbsp;€');

                $reelZone.show();

            } else {

                $reel.empty();

                $reelZone.hide();

            }

        };

    }





    function handleOnetime($el, selected) {

        var $predefs = $el.find('[name="unefois-montant"]'),

            $libre = $el.find('[name="unefois-libre"]'),

            $reel =  $el.find('[data-role="cout-reel"]'),

            $reelZone = $reel.closest('[data-role="container"]'),

            $radios = $el.find('input[type="radio"]');



        var filler = reality({

            predefs: $predefs,

            libre: $libre,

            reel:  $reel,

            reelZone: $reelZone

        });



        $predefs.on('click', function() {

            $libre.val('');

            selected($el);

            filler();

        });

        $libre.on('keyup mouseup change blur', function() {

            selected($el);

            filler();

        });

        $libre.on('keydown', function() {

            console.log('d');

            $radios.removeAttr('checked');

        });



        filler();

    }



    function handleRegular($el, selected) {

        var $libre = $el.find('[name="regulier-libre"]'),

            $reel =  $el.find('[data-role="cout-reel"]'),

            $reelZone = $reel.closest('[data-role="container"]'),

            $radios = $el.find('input[type="radio"]');



        var filler = reality({

            libre: $libre,

            reel:  $reel,

            reelZone: $reelZone

        });



        $libre.on('keyup mouseup change blur', function() {

            selected($el);

            filler();

        });

        $radios.on('click', function() {

            selected($el);

        });

        filler();

    }



    function handleCoords($el) {

        function toggle(ison) {

            $el.find('[data-field]').filter(function() {

                return $(this).data('field').startsWith('coords-moral-');

            }).toggle(ison);



            var $grp = $el.find('[data-field="coords-groupe"]');

            $grp.find('select').prop('required', !ison);

            $grp.find('._form-mandatory').toggle(!ison)

        }

        $el.on('click', '[name="coords-moral"]', function() {

            var moral = this.value === 'y'

            toggle(moral);

        });

        toggle($el.find('[name="coords-moral"]:checked').val() === 'y')

    }





    function init(opts) {

        var $onetime = $(opts.el.onetime),

            $regular = $(opts.el.regular),

            $mode = $(opts.el.mode),

            $form = $(opts.el.form);



        function selected($el) {

            var s = $el.get(0).id;

            $onetime.removeClass('_active');

            $regular.removeClass('_active');

            $el.addClass('_active');



            var $inactive = $onetime.hasClass('_active') ? $regular : $onetime;

            $inactive.find('input[type="radio"]').removeAttr('checked');

            $inactive.find('input[type="text"]').val('');

            $inactive.find('input[type="number"]').val('');

            $inactive.find('[data-role="cout-reel"]').empty();

            $inactive.find('[data-role="container"]').hide();



            if ($el === $regular) {

                if (!$regular.find('input[type="radio"]:checked').length)

                    $regular.find('input[type="radio"]').first().prop('checked', 'checked');

            }



            $mode.val(s);

            $form.find('[data-mode]').hide();

            $form.find('[data-mode="' + s + '"]')

                .show()

                .find('input').first().prop('checked', 'checked');

        }



        if ($mode.val() === 'regular') {

            selected($regular);

        } else {

            selected($onetime);

        }



        handleOnetime($onetime, selected);

        handleRegular($regular, selected);

        handleCoords($form);

    }



    return init;

})(window.SNC.Don, window.jQuery);
